import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const Perks = () => {
  return (
    <div
      className="Perks p-100 perks_ai"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Comprehensive Suite of <span>AI-Based Solutions</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              spaceBetween={20}
              // autoplay={false}
              modules={[Autoplay]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1366: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1600: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
              className="high_on_demand_slider"
            >
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content ">
                    <h4>
                      Natural Language
                      <br /> Processing (NLP)
                    </h4>
                    <p>
                      Our NLP solutions enable models to understand, interpret,
                      and generate responses in human language. We have built AI
                      solutions that are currently powering the customer
                      representation and analysis departments of 13 businesses
                      through text analysis, sentiment analysis, language
                      translation, assessment grading, fitness and study
                      recommendation.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Computer
                      <br /> Vision
                    </h4>
                    <p>
                      TekRevol’s computer vision solutions enable algorithms to
                      interpret and make decisions based on visual data. These
                      are robust AI solutions that work exceptionally well for
                      healthcare, security, and retail because of features like
                      image and video recognition, object detection, facial
                      recognition, and augmented reality. Currently, three of
                      TekRevol’s AI solutions are empowering the operations in
                      waste collection businesses.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Generative
                      <br /> AI
                    </h4>
                    <p>
                      We build artificial intelligence solutions using
                      generative AI models. These solutions, according to the
                      unique business requirements of our clients, can create
                      new content and repurpose existing one in text, images,
                      music and video formats. So if you’re in an industrial
                      sector that’s creative and requires innovative outputs,
                      for example media and journalism, we can build an
                      AI-powered solution that will help you expedite the
                      content development process for internal and external
                      stakeholders.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Speech
                      <br /> Recognition
                    </h4>
                    <p>
                      We build Speech Recognition solutions that convert spoken
                      language into text, facilitate voice-activated systems,
                      transcription services, and enhance the accessibility for
                      various applications. If you already have a user-centric
                      mobile application, in a sensitive consumer setting like
                      ecommerce, build a medium-scale speech recognition
                      feature, deploy it in your mobile app and transform the
                      in-app shopping experience for your customers.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Chatbot
                      <br /> Development
                    </h4>
                    <p>
                      TekRevol develops intelligent chatbots that simulate human
                      conversation, provide customer support, automate
                      repetitive tasks, and improve user interactions on
                      websites and mobile apps. These chatbots have proven
                      beneficial in ecommerce, proptech, healthcare, legal and
                      fintech businesses and have yielded 40% ROI in 7 months of
                      deployment.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content ">
                    <h4>
                      Natural Language
                      <br /> Processing (NLP)
                    </h4>
                    <p>
                      Our NLP solutions enable models to understand, interpret,
                      and generate responses in human language. We have built AI
                      solutions that are currently powering the customer
                      representation and analysis departments of 13 businesses
                      through text analysis, sentiment analysis, language
                      translation, assessment grading, fitness and study
                      recommendation.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Computer
                      <br /> Vision
                    </h4>
                    <p>
                      TekRevol’s computer vision solutions enable algorithms to
                      interpret and make decisions based on visual data. These
                      are robust AI solutions that work exceptionally well for
                      healthcare, security, and retail because of features like
                      image and video recognition, object detection, facial
                      recognition, and augmented reality. Currently, three of
                      TekRevol’s AI solutions are empowering the operations in
                      waste collection businesses.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Generative
                      <br /> AI
                    </h4>
                    <p>
                      We build artificial intelligence solutions using
                      generative AI models. These solutions, according to the
                      unique business requirements of our clients, can create
                      new content and repurpose existing one in text, images,
                      music and video formats. So if you’re in an industrial
                      sector that’s creative and requires innovative outputs,
                      for example media and journalism, we can build an
                      AI-powered solution that will help you expedite the
                      content development process for internal and external
                      stakeholders.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Speech
                      <br /> Recognition
                    </h4>
                    <p>
                      We build Speech Recognition solutions that convert spoken
                      language into text, facilitate voice-activated systems,
                      transcription services, and enhance the accessibility for
                      various applications. If you already have a user-centric
                      mobile application, in a sensitive consumer setting like
                      ecommerce, build a medium-scale speech recognition
                      feature, deploy it in your mobile app and transform the
                      in-app shopping experience for your customers.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="perks-box perks_web">
                  <div className="perks-content">
                    <h4>
                      Chatbot
                      <br /> Development
                    </h4>
                    <p>
                      TekRevol develops intelligent chatbots that simulate human
                      conversation, provide customer support, automate
                      repetitive tasks, and improve user interactions on
                      websites and mobile apps. These chatbots have proven
                      beneficial in ecommerce, proptech, healthcare, legal and
                      fintech businesses and have yielded 40% ROI in 7 months of
                      deployment.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
